<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-3">
          <nav>
            <ul class="footer-menu" role="menu">
              <li role="menuitem">
                <router-link :to="{path:'/portal/inicio'}">Inicio</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="copyright">

      </div>
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style>
.footer-menu li a {
  color: #606266 !important;
}

.footer p {
  font-size: 12px;
}
</style>
